/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./PayoutSuccess.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class PayoutSuccess extends Component {
  render() {
    const languageObj = this.props.languageObj;
    return (
      <div className="PayoutSuccess-view">
        <div className="PayoutSuccess-header">
          <Link to="/AccountOverview">
            <div className="PayoutSuccess-logo"></div>
          </Link>
        </div>

        <div className="PayoutSuccess-payoutContainer">
          <div className="PayoutSuccess-payoutIcn"></div>
          <div className="PayoutSuccess-text">
            {" "}
            {languageObj.text[0]}
            <p />
            {languageObj.text[1]}
            <br />
            {languageObj.text[2]}
          </div>

          <div
            onClick={(e) => {
              this.props.history.push({ pathname: "/OrgSettings", page: 4 });
            }}
            className="PayoutSuccess-doneBtn"
          >
            {languageObj.doneBtn}
          </div>
        </div>
      </div>
    );
  }
}

PayoutSuccess.propTypes = {
  languageObj: PropTypes.object,
};

export default PayoutSuccess;
